import { render, staticRenderFns } from "./ItemCombo.vue?vue&type=template&id=4beafbd5&lang=html"
import script from "./ItemCombo.vue?vue&type=script&lang=js"
export * from "./ItemCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports